<template>
    <div class="px-3 pt-3 pb-3">
        <v-row no-gutters dense>
            <v-col cols="12" sm="6" md="4"
                ><span class="label">{{ $t('Наименование контрагента') }}</span></v-col
            >
            <v-col cols="12" sm="6" md="8"
                ><span class="gray--text">{{ CIT.contractor_name }}</span></v-col
            >
        </v-row>
        <v-row no-gutters dense>
            <v-col cols="12" sm="6" md="4"
                ><span class="label">{{ $t('Юридический адрес') }}</span></v-col
            >
            <v-col cols="12" sm="6" md="8"
                ><span class="gray--text">{{ CIT.address_full_name }}</span></v-col
            >
        </v-row>
        <v-row no-gutters dense>
            <v-col cols="12" sm="6" md="4"
                ><span class="label">{{ $t('БИН / ИИН') }}</span></v-col
            >
            <v-col cols="12" sm="6" md="8"
                ><span class="gray--text">{{ CIT.bin }}</span></v-col
            >
        </v-row>
        <v-row no-gutters dense>
            <v-col cols="12" sm="6" md="4"
                ><span class="label">{{ $t('Должность и ФИО первого руководителя') }}</span></v-col
            >
            <v-col cols="12" sm="6" md="8"
                ><span class="gray--text">{{
                    CIT.job_pos_type_name + ' ' + CIT.person_last_name + ' ' + CIT.person_first_name + CIT.person_middle_name
                }}</span></v-col
            >
        </v-row>
        <v-row
            ><v-col cols="12">
                <v-expansion-panels>
                    <v-expansion-panel>
                        <v-expansion-panel-header>
                            <span class="label"> {{ $t('Контакты') }}</span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-btn color="primary" @click="showNew"
                                ><v-icon>mdi-phone-plus</v-icon><span>{{ $t('Добавить') }}</span></v-btn
                            >
                            <div class="mt-3">
                                <ContactAddEdit ref="addEditContact" @contactSaved="onContactSave" :contacts="newContact" :isNew="true" />
                            </div>
                            <v-row dense no-gutters class="mt-5">
                                <v-col cols="12" sm="12" md="6" v-for="x in contacts" :key="x.contact_type_name + '_' + x.contr_contact_value">
                                    <ContactAddEdit :contacts="x" @contactSaved="onContactSave" />
                                </v-col>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-data-table
                    :options.sync="contractPagination"
                    disable-sort
                    :loading="ContractListLoading"
                    :headers="contractsHeader"
                    :items="CCT"
                    :server-items-length="ContractLength"
                    :footer-props="{ 'items-per-page-options': $vuetify.breakpoint.xsOnly ? [1] : [3, 10, 15, 20, 25] }"
                    @click:row="handleClick"
                >
                    <template v-slot:item.contract_open_date="{ item }">
                        <span>{{ item.contract_open_date | formatDate }}</span>
                    </template>
                    <template v-slot:item.contract_end_date="{ item }">
                        <span>{{ item.contract_end_date | formatDate }}</span>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-row no-gutters dense class="d-flex align-end justify-end">
            <ObjectFilter />
        </v-row>
        <v-row no-gutters dense>
            <v-col cols="12">
                <v-data-table
                    :options.sync="objectPagination"
                    disable-sort
                    :loading="ObjectListLoading"
                    :headers="objectsHeader"
                    :items="OLT"
                    :server-items-length="ObjectLength"
                    :footer-props="{ 'items-per-page-options': $vuetify.breakpoint.xsOnly ? [1] : [3, 10, 15, 20, 25] }"
                >
                    <template v-slot:item.date_obj_contract_begin="{ item }">
                        <span>{{ item.date_obj_contract_begin | formatDate }}</span>
                    </template>
                    <template v-slot:item.date_obj_contract_end="{ item }">
                        <span>{{ item.date_obj_contract_end | formatDate }}</span>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import translate from '@/utils/translate.util';
import ObjectFilter from '@/components/ui/ObjectFilter';
import ContactAddEdit from './ui/ContactAddEdit.vue';
export default {
    data: () => ({
        SelectedContract: {},
        ContractRid: 0,
        newContact: { contact_type_rid: null, contact_type_name: null, contr_contact_value: null }
    }),
    name: 'Contractor',
    components: {
        ObjectFilter,
        ContactAddEdit
    },
    computed: {
        ...mapState('request', [
            'ContractInfo',
            'ContactList',
            'ContractList',
            'ContractListLoading',
            'ObjectList',
            'ObjectListLoading',
            'ContractLength',
            'ObjectLength',
            'ObjectPagination',
            'ContractPagination'
        ]),
        ...mapState('users', ['userInfo']),
        objectPagination: {
            get() {
                return this.ObjectPagination;
            },
            async set(val) {
                this.$store.commit('request/setObjectPagination', val);
                if (this.SelectedContract.contract_rid)
                    await this.getContractObjects({
                        ContractRid: this.SelectedContract.contract_rid,
                        iLimit: val.itemsPerPage,
                        iOffset: val.itemsPerPage * (val.page - 1)
                    });
            }
        },
        contractPagination: {
            get() {
                return this.ContractPagination;
            },
            async set(val) {
                this.$store.commit('request/setContractPagination', val);
                if (this.ContractRid != 0)
                    await this.getContractContracts({ ContractRid: this.ContractRid, iLimit: val.itemsPerPage, iOffset: val.itemsPerPage * (val.page - 1) });
            }
        },
        OLT() {
            return translate(this.ObjectList, 'full', this.$i18n.locale);
        },
        CCT() {
            return translate(this.ContractList, 'full', this.$i18n.locale);
        },
        CIT() {
            return translate(this.ContractInfo, 'full', this.$i18n.locale);
        },
        contacts() {
            return translate(this.ContactList, 'full', this.$i18n.locale);
        },
        contractsHeader: function() {
            return [
                {
                    text: this.$t('Номер договора'),
                    value: 'contract_number'
                },
                {
                    text: this.$t('Вид потребителя'),
                    value: 'abonent_type_name'
                },
                {
                    text: this.$t('Категория потребления'),
                    value: 'consump_group_name'
                },
                {
                    text: this.$t('Специфика деятельности'),
                    value: 'specifications'
                },
                {
                    text: this.$t('Дата заключения'),
                    value: 'contract_open_date'
                },
                {
                    text: this.$t('Дата окончания'),
                    value: 'contract_end_date'
                },
                {
                    text: this.$t('Административный район'),
                    value: 'district_name'
                }
            ];
        },
        objectsHeader: function() {
            return [
                {
                    text: this.$t('Код объекта'),
                    value: 'obj_contract_number'
                },
                {
                    text: this.$t('Наименование объекта'),
                    value: 'object_name'
                },
                {
                    text: this.$t('Адрес объекта'),
                    value: 'address_full_name'
                },
                {
                    text: this.$t('Административный район'),
                    value: 'district_name'
                },
                {
                    text: this.$t('Эксплуатационный район'),
                    value: 'exploit_district_name'
                },
                {
                    text: this.$t('Тепловой участок'),
                    value: 'exploit_area_name'
                },
                {
                    text: this.$t('Инженер района'),
                    value: 'person_ea_name_show'
                },
                {
                    text: this.$t('Период обслуживания с'),
                    value: 'date_obj_contract_begin'
                },
                {
                    text: this.$t('Период обслуживания по'),
                    value: 'date_obj_contract_end'
                }
            ];
        }
    },
    methods: {
        ...mapActions('request', ['getContractInfo', 'getContractContracts', 'getContractObjects', 'getContactTypes', 'updateContacts']),
        ...mapActions('users', ['getUserInfo']),
        async handleClick(item) {
            this.SelectedContract = item;
            this.$store.commit('request/setSelectedContract', item);
            this.getContractObjects({ ContractRid: item.contract_rid, iLimit: 3, iOffset: 0 });
        },
        showNew() {
            this.$refs.addEditContact.openNew();
        },
        async onContactSave(savedData) {
            await this.updateContacts({ iContractor_rid: this.ContractInfo.contractor_rid, nvcContacts: { contacts: [savedData] } });
            await this.getContractInfo({ ContractRid: this.ContractRid });
        }
    },
    async created() {
        await this.getUserInfo();
        if (this.userInfo && this.userInfo.user_data && this.userInfo.user_data.isas_contract_rid) {
            this.ContractRid = this.userInfo.user_data.isas_contract_rid;
        } else {
            this.ContractRid = 0;
        }
        this.$store.commit('request/setObjectListLoading', false);
        this.$store.commit('request/setObjectList', []);
        this.$store.commit('request/setObjectLength', 0);
        await this.getContractInfo({ ContractRid: this.ContractRid });
        await this.getContractContracts({ ContractRid: this.ContractRid, iLimit: 3, iOffset: 0 });
        await this.getContactTypes();
    }
};
</script>
